import React from "react";
import { TabbedShowLayout, Tab, TopToolbar, ShowProps } from "react-admin";
import { Grid } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import Summary from "./Summary";
import Sibling from "./Sibling";
import Address from "./Address";
import { GetParam, StudentResources } from "utils/tools";
import StudentSchedule from "./StudentSchedule";
import ActivateStudentButton from "./components/ActivateStudentButton";
import Route from "./Route";
import InactiveStudentButton from "./components/InactiveStudentButton";
import InternalNote from "./InternalNote";
import Permission from "./Permission";
import SplitPayment from "./SplitPayment";
import ShowWrapper from "../../components/ShowWrapper";

const StudentShow = (props: ShowProps) => {
  const param = GetParam();
  const { id } = props;

  let breadcrumbValue;

  if (param.get("parentId")) {
    breadcrumbValue = [
      {
        title: "Parents",
        link: `/parents/${param.get("parentId")}/show`,
      },
      {
        title: "Students",
        link: `/parents/${param.get("parentId")}/show/2`,
      },
      {
        title: id,
        link: "",
      },
    ];
  } else {
    breadcrumbValue = [
      {
        title: "Students",
        link: `/students`,
      },
      {
        title: id,
        link: "",
      },
    ];
  }

  const breadcrumb = breadcrumbValue;

  const StudentShowAction = (props: any) => {
    const StudentResource = StudentResources(Number(id));

    return (
      <TopToolbar>
        {StudentResource?.status === "inactive" ? (
          <ActivateStudentButton studentId={id} {...props} />
        ) : (
          // <TerminateStudentButton
          //   studentId={id}
          //   parentId={StudentResource?.parent?.id}
          //   {...props}
          // />
          <InactiveStudentButton studentId={id} {...props} />
        )}
      </TopToolbar>
    );
  };

  return (
    <>
      <ShowWrapper
        breadcrumb={breadcrumb}
        isFullName
        actions={<StudentShowAction />}
        {...props}
      >
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
              <Tab label="Schedule">
                <StudentSchedule {...props} />
              </Tab>
              <Tab label="Routes & Not Taking Reports">
                <Route {...props} />
              </Tab>
              <Tab label="Address">
                <Address {...props} />
              </Tab>
              <Tab label="Siblings">
                <Sibling {...props} />
              </Tab>
              <Tab label="Permissions">
                <Permission {...props} />
              </Tab>
              <Tab label="Payment Setting">
                <SplitPayment {...props} />
              </Tab>
              <Tab label="Internal Note">
                <InternalNote {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </ShowWrapper>
    </>
  );
};

export default StudentShow;
